import Crypto from './crypto.service';
import Socket from './socket.service';
import { receiveAccounts, fetchAccounts, deletedAccount } from '../actions/accounts';
import { receiveExpenses, fetchExpenses, removeMonths, deletedExpense } from '../actions/expenses';
import { isLoggedIn } from '../actions/user';

export default (dispatch, getState) => {
  Socket.subscribe('calculate', function(data: string[], respond: Function) {
    process.env.NODE_ENV !== 'production' && console.log(`socket] <-- calculate`);
    const response = data
      .map(d => (d !== '0' && d ? Crypto.decrypt(d) : '0'))
      .map((d, i) => (i % 2 === 0 ? Number(d) : -Number(d)))
      .reduce((sum, b) => sum + b);
    respond(null, Crypto.encrypt(response.toString()));
  });

  Socket.subscribe('receiveAccounts', accounts => {
    process.env.NODE_ENV !== 'production' && console.log(`socket] <-- receiveAccounts`);
    dispatch(receiveAccounts(accounts));
  });

  Socket.subscribe('deletedAccount', account => {
    process.env.NODE_ENV !== 'production' && console.log(`socket] <-- deletedAccount`);
    account && dispatch(deletedAccount(account));
  });

  Socket.subscribe('receiveExpenses', expenses => {
    process.env.NODE_ENV !== 'production' && console.log(`socket] <-- receiveExpenses`);
    dispatch(receiveExpenses(expenses));
  });

  Socket.subscribe('deletedExpense', expense => {
    process.env.NODE_ENV !== 'production' && console.log(`socket] <-- deletedExpense`);
    dispatch(deletedExpense(expense));
  });

  async function tryToFetchAccounts(timeout = 100) {
    await new Promise(r => setTimeout(r, timeout));
    const { isLoggedIn, isPasswordSet, shouldPasswordBeSet } = getState();
    if (isLoggedIn && (isPasswordSet || !shouldPasswordBeSet)) {
      dispatch(fetchAccounts());
    } else {
      tryToFetchAccounts(timeout * 2);
    }
  }

  Socket.subscribe('connect', tryToFetchAccounts);

  Socket.subscribe('reconnect', async () => {
    await dispatch(isLoggedIn());

    await dispatch(removeMonths());
    // TODO fetch if visible month.
    await dispatch(fetchExpenses());

    await tryToFetchAccounts();
  });
};



// WEBPACK FOOTER //
// ./src/services/subscribe-sockets.service.ts